import { gql } from '@apollo/client';

export type GET_ORGANISATION_INSIGHT_USERSType = {
  data: {
    id: string | null;
    startDate: string | null;
    endDate: string | null;
    user: {
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string;
    };
  }[];
};

export const GET_ORGANISATION_INSIGHT_USERS = gql`
  query GetOrganisationInsightUsers($insightId: ID!) {
    data: getOrganisationInsightUsers(insightId: $insightId) {
      id
      startDate
      endDate
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
